
import { Skeleton } from "@/components/ui/skeleton"
import { ArrowLeft } from "lucide-react"

export default function BookingModeSkeleton() {
  return (
    <div className="w-full mx-auto md:px-4 md:pb-24 pt-2 font-sans animate-pulse">
      {/* Progress Pill Skeleton */}
      <div className="hidden md:block mb-6">
        <Skeleton className="h-2 w-full max-w-[80%] rounded-full " />
      </div>

      <div className="flex flex-col items-center mt-4 md:mt-8 mb-8 md:mb-0">
        <div className="w-full max-w-3xl rounded-3xl bg-white shadow-sm border border-gray-100 px-2 py-4 md:px-8 md:py-8 relative overflow-hidden">
          
           {/* Center Text */}
           <div className="flex flex-col items-center mb-10">
             <Skeleton className="h-8 w-48 mb-2  rounded-md" />
             <Skeleton className="h-4 w-64  rounded-md" />
           </div>

           {/* Cards Grid */}
           <div className="grid grid-cols-2 gap-3 md:gap-8 max-w-3xl mx-auto mb-8 px-2 md:px-0">
             {/* Card 1 */}
             <div className="flex flex-col items-center p-4 md:p-8 rounded-2xl md:rounded-3xl border-2 border-gray-100 bg-white shadow-sm h-[200px] md:h-[280px]">
                <Skeleton className="w-12 h-12 md:w-20 md:h-20 rounded-full mb-3 md:mb-5 " />
                <Skeleton className="h-5 w-24 md:h-7 md:w-32 mb-2 " />
                <Skeleton className="h-3 w-full md:w-48 " />
                <Skeleton className="h-3 w-3/4 md:w-36 mt-2 " />
             </div>

             {/* Card 2 */}
             <div className="flex flex-col items-center p-4 md:p-8 rounded-2xl md:rounded-3xl border-2 border-gray-100 bg-white shadow-sm h-[200px] md:h-[280px]">
                <Skeleton className="w-12 h-12 md:w-20 md:h-20 rounded-full mb-3 md:mb-5 " />
                <Skeleton className="h-5 w-24 md:h-7 md:w-32 mb-2 " />
                <Skeleton className="h-3 w-full md:w-48 " />
                <Skeleton className="h-3 w-3/4 md:w-36 mt-2 " />
             </div>
           </div>
        </div>
      </div>

      {/* Back Button Skeleton */}
      <div className="flex justify-start mt-8 px-2 md:px-0">
         <div className="w-24 h-12 rounded-full border border-gray-200 bg-white flex items-center justify-center gap-2">
            <ArrowLeft className="w-4 h-4 text-gray-300" />
            <Skeleton className="h-4 w-8 " />
         </div>
      </div>
    </div>
  )
}
